import { useNavigate } from "react-router-dom";
import RequestQuizModal from "../../common/RequestQuizModal";
import { getDaysRemaining } from "../../../../../utils/dateUtils";
import Badge from "../../../../ReusableComponent/Badge";
import { technologyIcon } from "../../../../Assessment/component/assessment/technologyIcon";
import Button from "../../../../ReusableComponent/Button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getCandidateReviewReport } from "../../../actions"
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector  } from "react-redux";
import { Modal } from "antd";
import { FaDownload } from "react-icons/fa6";
import datacodeImg from "../../../../../assets/images/datacode_certificatre_logo.png"
const QuizzesCard = ({ item, index }) => {
  const certificateRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
   const { candidateReportReviewDetails } = useSelector(
    (state) => state.quizTest
  );


   const [certificateModal, setCertificateModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showCertificate, setShowCertificate] = useState(false);
  const [availableAssessments, setAvailableAssessments] = useState([]);

    const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const handleSubmitStart = () => {
    if (item?.quizCategory === "assessment") {
      navigate(`/assessments/${item._id}`);
    } else {
      navigate(`/quiz/test/${item._id}`);
    }
  };

  const daysLeft = getDaysRemaining(item.endDate, 15);
  const showExpiry = getDaysRemaining(item.inviteExpDate, 7);
  const quizTechnology = item?.quizTechnology.toLowerCase();
  const techIcon = technologyIcon.find(
    (tech) => tech?.technologyName?.toLowerCase() === quizTechnology
  );

  
  // ADDED: Start quiz again
  const startQuizAgain = (item) => {
    navigate(`/assessments/${item._id}`);
  };

  
   const renderActionButton = (item) => {
  /* ===============================
     1️⃣ PASSED → DOWNLOAD CERTIFICATE
  ================================ */
  if (item.isAttempted && item.isPassed) {
    return (
      <Button
        size="sm"
        onClick={() => openCertificateModal(item._id)}
      >
        🎓 Download Certificate
      </Button>
    );
  }

  /* ===============================
     2️⃣ NOT ATTEMPTED → START QUIZ
  ================================ */
  if (
    !item.isAttempted &&
    (
      item.access === "public" ||
      (item.access === "invite" &&
        item.invited &&
        item.inviteStatus !== "expired")
    )
  ) {
    return (
      <Button
        size="sm"
        onClick={handleSubmitStart}
      >
        🚀 Start {item.quizCategory}
      </Button>
    );
  }

  /* ===============================
     3️⃣ FAILED → TRY AGAIN (PUBLIC)
  ================================ */
  if (
    item.isAttempted &&
    !item.isPassed &&
    item.access === "public"
  ) {
    return (
      <Button
        size="sm"
        onClick={() => startQuizAgain(item)}
      >
        🔁 Try Again
      </Button>
    );
  }

  /* ===============================
     4️⃣ INVITE FAILED OR EXPIRED
  ================================ */
  if (
    item.access === "invite" &&
    item.invited &&
    (
      !item.isPassed ||
      item.inviteStatus === "expired"
    )
  ) {
    return (
      <Button size="sm">
        <RequestQuizModal
          label="Request Quiz"
          quiz={item}
        />
      </Button>
    );
  }

  return null;
};

 const downloadCertificate = async () => {
    const certificateElement = certificateRef.current;
    if (certificateElement) {
      const canvas = await html2canvas(certificateElement, {
        scale: 2,
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const imgWidth =
        canvas.width > canvas.height
          ? pdfWidth
          : (pdfWidth / canvas.height) * canvas.width;

      const imgHeight =
        canvas.width > canvas.height
          ? (pdfHeight / canvas.width) * canvas.height
          : pdfHeight;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      pdf.save("certificate.pdf");
    }
  };

  const openCertificateModal = (item) => {
    setCertificateModal(true);
    setShowCertificate(false);
    setProgress(0);
    dispatch(getCandidateReviewReport(item)).then(() => {
      console.log(candidateReportReviewDetails, "details");
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setShowCertificate(true);
            return 100;
          }
          return prev + 10;
        });
      }, 100);
    });
  };


  return (
    <>
      <div className="col-lg-4 col-md-6 mb-4" key={index}>
        <div className="h-100 hover-card position-relative card-quizzes watermark">
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div className="d-flex gap-2 flex-wrap">
                {item?.quizTechnology && (
                  <Badge label={item?.quizTechnology} color="primary" />
                )}
                <Badge label="Beginner" color="success" />
                <Badge label={item?.access} color="info" />
                {item?.access === "invite" && item?.invited && (
                  <Badge label={item?.inviteStatus} color="warning" />
                )}
              </div>
              <div className="text-end">
                <div className="d-flex align-items-center gap-2 justify-content-end">
                  {techIcon?.technologyIconImageUrl ? (
                    <img
                      src={techIcon.technologyIconImageUrl}
                      alt={item?.quizTechnology}
                      width={22}
                      height={22}
                    />
                  ) : (
                    <span>🎯</span>
                  )}
                  <small className="text-white opacity-75 text-capitalize">
                    {item?.quizCategory}
                  </small>
                </div>
              </div>
            </div>
            <h5 className="text-white fw-bold mb-2 text-capitalize">
              {item?.quizTitle}
            </h5>
            {showExpiry ? (
              <span className="mb-2" style={{ color: "orange" }}>
                Expire in {showExpiry} days
              </span>
            ) : (
              " "
            )}
            <p className="text-white opacity-75 mb-3">
              Master ES6+, async/await, and modern JavaScript concepts
            </p>
            <div className="d-flex gap-1 flex-wrap mb-3">
              <span className="badge text-white card-badge">ES6</span>
              <span className="badge text-white card-badge">Promises</span>
              <span className="badge text-white card-badge">DOM</span>
            </div>
            <div className="row text-center mb-3">
              <div className="col-3">
                <div className="text-white fw-bold">{item?.duration} min</div>
                <small className="text-white opacity-75">Duration</small>
              </div>
              <div className="col-3">
                <div className="text-white fw-bold">
                  {item?.quizQuestions?.length}
                </div>
                <small className="text-white opacity-75">Questions</small>
              </div>
              <div className="col-3">
                <div className="text-white fw-bold">⭐ 4.8</div>
                <small className="text-white opacity-75">Rating</small>
              </div>
              <div className="col-3">
                <div className="text-white fw-bold"> {item?.completedBy?.length}</div>
                <small className="text-white opacity-75">Students</small>
              </div>
            </div>
            <div className="d-grid gap-2">
              <div  >
                {/* {!item?.isAttempted &&
                  (item.access === "public" ||
                    (item.access === "invite" &&
                      item?.invited &&
                      item?.inviteStatus !== "expired")) ? (
                  <div onClick={handleSubmitStart}>
                    🚀 Start {item?.quizCategory}
                  </div>
                ) : (
                  // add condition to check if invite is expired
                  <div>
                    {item?.access === "invite" ? (
                      item.inviteStatus === "expired" ? (
                        <div className="text-danger">Invite Expired</div>
                      ) : (
                        <RequestQuizModal
                          label="Request Quiz"
                          quiz={item}
                        />
                      )
                    ) : (
                      <div>Try Again</div>
                    )}
                  </div>
                ) */}
                {renderActionButton(item)}
                
              </div>

              {/* <div className="row mx-0 g-2">
                <div className="col-6">
                  <button className="btn btn-sm w-100 text-white card-btn">
                    👁️ Preview
                  </button>
                </div>
                <div className="col-6">
                  <button className="btn btn-sm w-100 text-white card-btn">
                    📊 Analytics
                  </button>
                </div>
              </div> */}
              {daysLeft ? 
                <span className="badge bg-danger">
                  {daysLeft} day{daysLeft !== 1 && "s"} left to attempt
                </span>
              : " "}
            </div>
          </div>
        </div>
      </div>
        {certificateModal && (
        <Modal
          width={850}
          open={certificateModal}
          title="Certificate"
          onCancel={() => setCertificateModal(false)}
          footer={[
            <button
              key="download"
              className="btn btn-success mx-2 vertical-align-middle"
              onClick={downloadCertificate}
              disabled={!showCertificate}
            >
              <span className="d-flex align-items-center">
                <FaDownload className="me-2" />
                <span>Download Certificate</span>
              </span>
            </button>,
            <button
              key="close"
              className="btn btn-primary"
              onClick={() => setCertificateModal(false)}
            >
              Close
            </button>,
          ]}
        >
          {!showCertificate ? (
            <div className="text-center">
              <p>Loading certificate...</p>
              <div
                style={{
                  margin: "20px auto",
                  width: "80%",
                  height: "20px",
                  borderRadius: "10px",
                  background: "rgba(200, 200, 200, 0.4)",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: `${progress}%`,
                    background: "linear-gradient(90deg, #6a11cb, #2575fc)",
                    borderRadius: "10px",
                    transition: "width 0.2s ease",
                  }}
                />
              </div>
              <span>{progress}%</span>
            </div>
          ) : (
            <div ref={certificateRef} className="row mx-0 border">
              <div className="col-12 px-0">
                <div className="row mx-0 w-100 h-100 datacode-certificate">
                  <div className="col-12 col-md-7 px-3 px-md-5">
                    <img
                      src={datacodeImg}
                      alt="Datacode logo"
                      className="my-4 my-md-5 mx-0 w-100 object-fit-cover"
                      height="100px"
                    />
                    <p className="mt-4 mt-md-5 mb-0 sub-title">
                      This certificate is presented to:
                    </p>
                  </div>
                  <div className="col-12 col-md-9 px-3 px-md-5">
                    <h1 className="pt-3 pt-md-0">
                      {currentUser?.firstName + " " + currentUser?.lastName ||
                        "Student Name"}
                    </h1>
                    <p className="mb-4 mb-md-5 description">
                      Assessment Completed, Success Achieved!
                      <br />
                      Congratulations on Your Well-Deserved Success!
                    </p>
                    <div className="my-4 my-md-5 pt-4 pt-md-5">
                      <span className="oragnised">ASSESSMENT ORGANIZED BY</span>
                      <br />
                      <span className="host">DATACODE COMMUNITY</span>
                    </div>
                    <span className="text-secondary">
                      Certificate Id : {candidateReportReviewDetails?._id}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};
export default QuizzesCard;
